export default __webpack_public_path__ + "img/Cinnamomum_verum.f5e5cbb0.jpg";